import React from "react";
import style from "./Switch.module.scss";

const SwitchButton = (props) => {

    return (
        <React.Fragment>
            <label className={style.SwitchClass}>
                <input
                    type="checkbox"
                    checked={props.value && !props.indeterminate ? 'checked' : ''}
                    onChange={e => props.onclick(e, props.value, props.tag)}
                    disabled={props.disabled ? props.disabled : false}
                ></input>
                <span
                    className={!props.indeterminate ? style.slider + ' ' + style.round : style.indeterminateSlider}></span>
            </label>
            {props.label ? <p className={style.SwitchLabel}>{props.label}</p> : ''}
        </React.Fragment>
    );
}

export default SwitchButton;